module.exports = __webpack_public_path__ + "71a9073456f3c0a611089dfe94642cc0.pdf";